import { Amplify } from "aws-amplify";

import environment from "@environment/variables";

export const configureAmplify = () => {
  Amplify.configure({
    Auth: {
      Cognito: environment.auth,
    },
    API: {
      GraphQL: {
        defaultAuthMode: "userPool",
        endpoint: process.env.VITE_AWS_GRAPHQL_API!,
        region: "us-east-1",
      },
      REST: {
        forgotPasswordApi: {
          endpoint: process.env.VITE_AWS_REST_API_URL!,
        },
      },
    },
  });
};
